export default "__VITE_ASSET__ZrTSM$mR__"